import { makeStyles } from "@material-ui/core/styles";

const useGlobalStyles = makeStyles((theme) => ({
    flexDisplay: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    flexColumn: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    justifyContentBetween: {
      justifyContent: 'space-between',
    },
    alignItemsCenter: {
      alignItems: 'center',
    },
  }));
  
  export default useGlobalStyles;


// WEBPACK FOOTER //
// ./src/globalStyles.js